import Glider from 'glider-js/glider';

export const inizializeGlider = () => {
    let gliderCardPromo = document.querySelectorAll('.js-card-promo');
    if(gliderCardPromo){
      gliderCardPromo.forEach(element => {
        new Glider(element, {
          slidesToShow: 1,
          dots: element.nextElementSibling.querySelector('.js-card-dots'),
          draggable: false,
          arrows: {
            prev: element.nextElementSibling.querySelector('.js-card-prev.glider-prev'),
            next: element.nextElementSibling.querySelector('.js-card-next.glider-next'),
          },
        }); 
      }); 
    }
  }


// WEBPACK FOOTER //
// ./scripts/modules/glider-initalize.js